import {Controller} from "react-hook-form";

import {useQuickAssistantSetupContext} from "../../../contexts";

import {Button} from "@/components/ui/button";
import {Input} from "@/components/ui/input";
import {Textarea} from "@/components/ui/textarea";
import {ToggleGroup, ToggleGroupItem} from "@/components/ui/ToggleGroup";

export const GeneralSettingsFormFields = () => {
  const {form} = useQuickAssistantSetupContext();

  return (
    <div className="flex flex-col gap-4">
      <div>
        <label
          className="text-label text-sm font-medium"
          htmlFor="quick-assistant-setup-general-settings-company-url"
        >
          Company URL
        </label>
        <Controller
          name="name"
          control={form.control}
          render={({field: {value, onChange}}) => (
            <div className="flex items-center gap-2 mt-1">
              <div className="flex flex-col align-stretch flex-1">
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="E.g. https://mycompany.com"
                  id="quick-assistant-setup-general-settings-company-url"
                />
              </div>

              <Button variant="outline-primary">Scrapte Website</Button>
            </div>
          )}
        />
      </div>

      <div>
        <label
          className="text-label text-sm font-medium"
          htmlFor="quick-assistant-setup-general-settings-custom-greeting"
        >
          Custom Greeting
        </label>
        <Controller
          name="name"
          control={form.control}
          render={({field: {value, onChange}}) => (
            <Textarea
              value={value}
              onChange={onChange}
              placeholder="E.g. https://mycompany.com"
              id="quick-assistant-setup-general-settings-custom-greeting"
            />
          )}
        />
      </div>

      <div>
        <label
          className="text-label text-sm font-medium"
          htmlFor="quick-assistant-setup-general-settings-voice"
        >
          Voice
        </label>
        <div className="flex">
          <Controller
            name="name"
            control={form.control}
            render={({field: {value, onChange}}) => (
              <ToggleGroup
                type="single"
                className="bg-muted p-1 rounded-md border border-border"
                value={value}
                onChange={onChange}
                defaultValue="male"
              >
                <ToggleGroupItem value="male" aria-label="Toggle bold">
                  Male
                </ToggleGroupItem>
                <ToggleGroupItem value="female" aria-label="Toggle italic">
                  Female
                </ToggleGroupItem>
              </ToggleGroup>
            )}
          />
        </div>
      </div>
    </div>
  );
};
